import React from 'react';
import {
  Edit,
  SimpleForm,
  DateField,
  Filter,
  TextInput,
  DateInput,
  List,
  Datagrid,
  ReferenceField,
  RichTextField,
  TextField,
  EditButton,
  FunctionField,
} from 'react-admin';

import PolarityField from './ui/PolarityField';

export const FacebookPostsList = props => (
  <List title="Facebook Posts" {...props} sort={{ field: 'publish_date', order: 'desc' }} filters={<DateFilter />}>
    <Datagrid>
      <ReferenceField label="Page" source="page.id" addLabel reference="facebookpages">
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        sortable={false}
        source="id"
        label="Post"
        render={(record, source) => (
          <a href={`https://facebook.com/${record[source]}`} target="_blank" rel="noopener noreferrer">
            {record['message'] ? record['message'] : record['link_title']}
          </a>
        )}
      />
      <PolarityField source="tag" />
      <DateField source="publish_date" showTime={true} />
      <EditButton label="" />
    </Datagrid>
  </List>
);

const DateFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <DateInput label="Published Before" source="range.publish_date.lte" />
    <DateInput label="Published After" source="range.publish_date.gte" />
  </Filter>
);

export const FacebookPostEdit = props => (
  <Edit title="Facebook Post" {...props}>
    <SimpleForm>
      <ReferenceField label="Page" source="page.id" addLabel reference="facebookpages">
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        sortable={false}
        source="id"
        label="Post"
        render={(record, source) => (
          <a href={`https://facebook.com/${record[source]}`} target="_blank" rel="noopener noreferrer">
            {record['message'] ? record['message'] : record['link_title']}
          </a>
        )}
      />

      <RichTextField source="message" />
      <TextField source="link_title" />
      <DateField source="publish_date" />
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/facebookposts.js